<template>
    <div class="container">
        <md-dialog :md-active.sync="modCrearTipoMoneda" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.codigo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="codigo" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.descripcion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="descripcion" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.acronimo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="acronimo" class="form-control">
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <md-button class="md-primary" @click="guardarTipoMoneda">{{ labels.save }}</md-button>
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import TipoMoneda from '../../../services/TipoMoneda';

export default {
    name : 'Crear',
    props: ['modCrearTipoMoneda'],
    data: () => ({
        codigo : null,
        descripcion : '',
        acronimo : '',
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Crear tipo moneda',
                    codigo : 'Código',
                    descripcion : 'Descripción',
                    acronimo : 'Acrónimo',
                    save : 'Guardar',
                    close : 'Cerrar',
                }
            }else{
                return {
                    title : 'Create currency type',
                    codigo : 'Code',
                    descripcion : 'Description',
                    acronimo : 'Acronym',
                    save : 'Save',
                    close : 'Close',
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        guardarTipoMoneda(){
            const dataForm = [
                this.codigo,
                this.descripcion,
                this.acronimo
            ]

            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{
                let info = {
                    'moneda' : this.codigo,
                    'descripcion' : this.descripcion,
                    'acronimo' : this.acronimo,
                    'idUser' : this.$store.state.userId
                }
                // console.log(info);
                TipoMoneda.createTipoMoneda(info)
                .then((res) => {
                    if(res.status == 201){
                        this.$toast.success(res.data.message)
                        location. reload()
                    
                    }else if(res.status == 204){
                        this.$toast.error('Tipo moneda ya existe.')
                        return
                    }
                })
                .catch((err) => console.log(err))
            }
        }
    }
}
</script>

<style>

</style>